import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import { Languages } from '@/enums'

Vue.use(Vuex)

export interface State {
	user: {
		age: '<23' | '23+' | false,
		preferredBranches: [string, string?, string?] | 'skipped' | false,
		criminalRecord: 'yes' | 'no' | false,
		selectedCrime: string | false,
		selectedPunishment: string | false,
		crimeWhen: { day: number, month: number, year: number } | 'skipped' | false,
		punishmentWhen: { day: number, month: number, year: number } | 'skipped' | false,
		punishmentLength: { amount: number, timeNotation: string } | 'skipped' | false
	},
	trackResults: boolean,
	language: Languages
}

const state: State = {
	user: {
		age: false,
		preferredBranches: false,
		criminalRecord: false,
		selectedCrime: false,
		selectedPunishment: false,
		crimeWhen: false,
		punishmentWhen: false,
		punishmentLength: false
	},
	trackResults: true,
	language: Languages.NL
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
